import $api from "@/zapi-frontend/shared/api/axios";

export async function postDeepResearch(
  questionId: number
): Promise<{ message: string; newChapterDetails: { projectChapterId: number; name: string } }> {
  const response = await $api.post(`/intelligence/questions/${questionId}/deep-research`);
  return response.data;
}
